import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import CAMHeader from "../../../components/Header/CAMHeader";
import "./dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import Label from "../../../components/Label/Label";
import DatePicker from "react-datepicker";
import {
  clearDashboardTilesApiStatus,
  getDashboardLogsTilesDta,
  getDrugTypeListBatchAndUserNames,
} from "../../../redux/investigation/actions";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import LogDrawer from "../NewTaskStatus/LogDrawer";
import FilterListIcon from "@mui/icons-material/FilterList";

const renderCard = (tile) => (
  <React.Fragment>
    <CardContent
      style={{
        border: tile?.batch_status === "Submitted" ? "2px solid green" : "none",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div style={{ flex: 1 }}>
        <Label text="Batch Name" fontSize="11px" />
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "150px",
            cursor: "pointer",
            height: "32px",
            lineHeight: "16px",
            wordBreak: "break-all",
          }}
          title={tile?.batch_name}
        >
          {tile?.batch_name}
        </div>

        <Label text="Template Name" fontSize="11px" paddingTop="10px" />
        <div
          style={{
            fontSize: "12px",
            fontWeight: 600,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: "150px",
            cursor: "pointer",
            height: "32px",
            lineHeight: "16px",
            wordBreak: "break-all",
          }}
          title={tile?.template}
        >
          {tile?.template}
        </div>

        <Divider style={{ margin: "10px 0px" }} />

        <Label text="Created By" fontSize="11px" />
        <Label text={tile?.created_by} fontSize="12px" fontWeight="600" />

        {tile?.batch_status === "Submitted" ? (
          <>
            <Label text="Status" fontSize="11px" paddingTop="10px" />
            <Label
              text="Submitted"
              fontSize="12px"
              fontWeight="600"
              color="green"
            />
          </>
        ) : (
          <>
            <Label text="Current Assignee" fontSize="11px" paddingTop="10px" />
            <Label
              text={tile?.assigned_to || "Not Assigned"}
              fontSize="12px"
              fontWeight="600"
            />
          </>
        )}
      </div>

      <Label text={tile?.created_on} fontSize="11px" paddingTop="10px" />
    </CardContent>
  </React.Fragment>
);
const Dashboard = () => {
  const dispatch = useDispatch();

  const dashboardLogsTilesApiStatus = useSelector(
    (state) => state?.investigation?.dashboardLogsTilesApiStatus
  );
  const productTypesBatchAndUserNames = useSelector(
    (state) => state?.investigation?.productTypesBatchAndUserNames
  );
  const dashboardLogsTilesData = useSelector(
    (state) => state?.investigation?.dashboardLogsTilesData
  );

  const [openLogDialog, setOpenLogDialog] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState();
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);

  const [products, setProducts] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [dateRange, setDateRange] = useState([null, null]);

  const [selectedStatus, setSelectedStatus] = useState("All");
  const [anchorEl, setAnchorEl] = useState(null);

  const [tilesData, settilesData] = useState([]);
  const statuses = [
    "All",
    "Mapping",
    "Extraction",
    "Validation",
    "Approval",
    "Submitted",
  ];

  useEffect(() => {
    dispatch(getDrugTypeListBatchAndUserNames());

    dispatch(
      getDashboardLogsTilesDta({
        selectedProduct,
        selectedTemplate,
        selectedBatch,
        dateRange: [oneMonthAgo, today],
      })
    );
    setDateRange([oneMonthAgo, today]);
  }, []);

  useEffect(() => {
    if (
      dashboardLogsTilesApiStatus &&
      dashboardLogsTilesApiStatus !== undefined
    ) {
      if (dashboardLogsTilesApiStatus?.apiError === true) {
        setMessage(dashboardLogsTilesApiStatus?.message);
        setErr(true);
        dispatch(clearDashboardTilesApiStatus());
      }
    }
  }, [dashboardLogsTilesApiStatus, dispatch]);

  const onChangeDates = (update) => {
    setDateRange(update);
  };

  const onClickSearch = () => {
    dispatch(
      getDashboardLogsTilesDta({
        selectedProduct,
        selectedTemplate,
        selectedBatch,
        dateRange,
      })
    );
    setSelectedStatus("All");
  };

  useEffect(() => {
    if (dashboardLogsTilesData 
      // && dashboardLogsTilesData.length > 0
    ) {
      settilesData([...dashboardLogsTilesData]);
    }
  }, [dashboardLogsTilesData]);

  const onClickClear = () => {
    setSelectedProduct("");
    setSelectedTemplate("");
    setSelectedTemplateId(null);
    setSelectedBatch("");

    setProducts([]);
    setTemplates([]);
    setBatches([]);

    setInitialData(productTypesBatchAndUserNames);

    dispatch(getDrugTypeListBatchAndUserNames());

    dispatch(
      getDashboardLogsTilesDta({
        selectedProduct: "",
        selectedTemplate: "",
        selectedBatch: "",
        dateRange: [oneMonthAgo, today],
      })
    );
    setDateRange([oneMonthAgo, today]);
  };

  const onCLickTile = (tile) => {
    setOpenLogDialog(true);

    setSelectedDetails({
      ...tile,
      project_name: tile?.template,
      type: "batch",
    });
  };

  const handleInfoClick = (projectName) => {
    setOpenLogDialog(true);

    setSelectedDetails({
      type: "project",
      project_name: projectName,
      project_id: selectedTemplateId,
    });
  };

  const closeLogDrawer = () => {
    setOpenLogDialog(false);
  };

  const setInitialData = (productTypesBatchAndUserNames) => {
    if (productTypesBatchAndUserNames?.length) {
      const uniqueProducts = [
        ...new Set(
          productTypesBatchAndUserNames.map((item) => item.product_name)
        ),
      ];
      setProducts(uniqueProducts);

      const uniqueTemplates = [
        ...new Set(
          productTypesBatchAndUserNames.map((item) => item.template_name)
        ),
      ];
      setTemplates(uniqueTemplates);

      const uniqueBatches = [
        ...new Set(
          productTypesBatchAndUserNames.map((item) => item.batch_name)
        ),
      ];
      setBatches(uniqueBatches);
    }
  };
  useEffect(() => {
    setInitialData(productTypesBatchAndUserNames);
  }, [productTypesBatchAndUserNames]);

  const handleProductChange = (_, value) => {
    const selectedProduct = value;
    setSelectedProduct(selectedProduct);
    setSelectedTemplate("");
    setSelectedTemplateId(null);
    setSelectedBatch("");
    if (selectedProduct) {
      const filteredTemplates = productTypesBatchAndUserNames
        .filter((item) => item.product_name === selectedProduct)
        .map((item) => item.template_name);
      setTemplates([...new Set(filteredTemplates)]);

      const filteredBatches = productTypesBatchAndUserNames
        .filter((item) => item.product_name === selectedProduct)
        .map((item) => item.batch_name);
      setBatches([...new Set(filteredBatches)]);
    }
  };

  const handleTemplateChange = (_, value) => {
    const selectedTemplate = value;

    setSelectedTemplate(selectedTemplate);
    setSelectedBatch("");

    if (selectedTemplate) {
      const filteredBatches = productTypesBatchAndUserNames
        .filter((item) => item.template_name === selectedTemplate)
        .map((item) => item.batch_name);
      setBatches([...new Set(filteredBatches)]);

      const selectedItem = productTypesBatchAndUserNames.find(
        (item) => item.template_name === selectedTemplate
      );
      if (selectedItem) {
        setSelectedProduct(selectedItem.product_name);
        setSelectedTemplateId(selectedItem?.project_id);
      }
    }
  };

  const handleBatchChange = (_, value) => {
    const selectedBatch = value;
    setSelectedBatch(selectedBatch);
    if (selectedBatch) {
      const selectedItem = productTypesBatchAndUserNames.find(
        (item) => item.batch_name === selectedBatch
      );
      if (selectedItem) {
        setSelectedProduct(selectedItem.product_name);
        setSelectedTemplate(selectedItem.template_name);
        setSelectedTemplateId(selectedItem?.project_id);
      }
    }
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setAnchorEl(null);

    const filteredData =
      status === "All"
        ? dashboardLogsTilesData
        : dashboardLogsTilesData.filter((tile) => tile.batch_status === status);

    settilesData([...filteredData]);
  };

  return (
    <Box className="logs-container">
      <CAMHeader />
      <CAMDrawer />

      <Container className="container">
        <div className="sticky-class">
          <Label
            paddingTop="15px"
            text="Audit Trail"
            fontSize="14px"
            fontWeight="600"
          />
          <Grid container spacing={1} sx={{ paddingTop: "10px" }}>
            <Grid item xs={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  size="small"
                  options={products || []}
                  renderInput={(params) => (
                    <TextField {...params} label="Product" />
                  )}
                  onChange={handleProductChange}
                  value={selectedProduct}
                />
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  size="small"
                  options={templates || []}
                  renderInput={(params) => (
                    <TextField {...params} label="Template" />
                  )}
                  onChange={handleTemplateChange}
                  value={selectedTemplate}
                />
              </FormControl>
            </Grid>

            <Grid item xs={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  size="small"
                  options={batches || []}
                  renderInput={(params) => (
                    <TextField {...params} label="Batch Name" />
                  )}
                  onChange={handleBatchChange}
                  value={selectedBatch}
                />
              </FormControl>
            </Grid>

            <Grid item xs={2} className="DateRangePickerAudit">
              <DatePicker
                className="DateRangePickerNewLogs"
                placeholderText="DD-MMM-YYYY To DD-MMM-YYYY"
                selectsRange={true}
                startDate={dateRange[0]}
                endDate={dateRange[1]}
                onChange={(update) => {
                  onChangeDates(update);
                }}
                isClearable={true}
                maxDate={new Date()}
              />
            </Grid>

            <Grid item xs={1}>
              <Button variant="contained" onClick={() => onClickSearch()}>
                Search
              </Button>
            </Grid>

            <Grid item xs={1}>
              <Button variant="outlined" onClick={() => onClickClear()}>
                Clear
              </Button>
            </Grid>

            <div
              style={{
                float: "right",
                marginLeft: "auto",
                marginRight: "20px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Label
                text={selectedStatus}
                fontSize="14px"
                fontWeight="500"
                paddingRight="5px"
              />
              <IconButton
                disabled={dashboardLogsTilesApiStatus?.loader}
                variant="text"
                size="small"
                onClick={(e) => setAnchorEl(e.currentTarget)}
              >
                <FilterListIcon />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                {statuses.map((status, idx) => (
                  <MenuItem
                    key={idx}
                    onClick={() => handleStatusChange(status)}
                  >
                    {status}
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </Grid>

          <Box style={{ padding: "15px 24px 15px 0px" }}>
            <Divider />
          </Box>
        </div>

        <Box
          display="flex"
          justifyContent="flex-end"
          padding="0px 24px 0px 0px"
        >
          <Button
            size="small"
            variant="outlined"
            onClick={() => handleInfoClick(selectedTemplate)}
            disabled={selectedTemplate === ""}
          >
            View Template Logs
          </Button>
        </Box>
        {dashboardLogsTilesApiStatus?.loader ? (
          <Box style={{ paddingRight: "24px" }}>
            <DashboardTableSkaleton />
          </Box>
        ) : (
          <>
            {tilesData.length > 0 ? (
              <Grid container spacing={1} style={{ paddingTop: "10px" }}>
                {tilesData?.map((tile, index) => (
                  <Grid
                    item
                    key={index}
                    style={{ paddingBottom: "10px", display: "flex" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <Card
                        variant="outlined"
                        className="log-card-box"
                        onClick={() => onCLickTile(tile)}
                        style={{
                          display: "flex",
                          flexDrection: "column",
                          flex: "1",
                          wordWrap: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {renderCard(tile)}
                      </Card>
                    </div>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <div className="no-data">
                <Label
                  text="No Data Found"
                  fontSize="16"
                  fontWeight="600"
                  padding="20px"
                />
              </div>
            )}
          </>
        )}
      </Container>

      {
        <LogDrawer
          openLogDialog={openLogDialog}
          closeLogDrawer={closeLogDrawer}
          selectedDetails={selectedDetails}
        />
      }

      {err && (
        <CustomizedSnackbars
          severity="error"
          state={err}
          text={message}
          handleClose={() => setErr(false)}
        />
      )}
    </Box>
  );
};

export default Dashboard;
